import { useState } from "react";
import API from "../api/axios";
import toast from "react-hot-toast";
import Layout from "../components/Layout";
import { useTheme } from "../context/ThemeContext";

const FEEDBACK_TYPES = [
  "General Feedback", "Bug Report", "Feature Request", "Billing Issue", "Other",
];

export default function Feedback() {
  const { theme } = useTheme();
  const [form, setForm] = useState({ feedback_type: "General Feedback", subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const card = {
    background: theme.cardBg,
    border: `1px solid ${theme.cardBorder}`,
    borderRadius: "14px",
    padding: "32px",
    marginBottom: "24px",
    maxWidth: "600px",
    boxShadow: theme.cardShadow,
  };
  const input = {
    background: theme.inputBg,
    border: `1px solid ${theme.inputBorder}`,
    borderRadius: "10px",
    padding: "12px 16px",
    color: theme.textPrimary,
    fontSize: "14px",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
  };

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await API.post("/feedback/", form);
      setSent(true);
      toast.success("Feedback sent successfully");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to send feedback");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div style={{ marginBottom: "32px" }}>
        <h1 style={{ fontSize: "28px", fontWeight: "700", color: theme.textPrimary, letterSpacing: "-0.5px" }}>
          Feedback
        </h1>
        <p style={{ fontSize: "14px", color: theme.textSecondary, marginTop: "4px" }}>
          Help us improve MartSense
        </p>
      </div>

      {sent ? (
        <div style={{ ...card, textAlign: "center", padding: "48px 32px" }}>
          <p style={{ fontSize: "48px", marginBottom: "16px" }}>🎉</p>
          <h2 style={{ fontSize: "22px", fontWeight: "700", color: theme.textPrimary, marginBottom: "12px" }}>
            Thank you for your feedback
          </h2>
          <p style={{ fontSize: "15px", color: theme.textSecondary, marginBottom: "24px", lineHeight: "1.6" }}>
            We read every message and use it to make MartSense better for you.
          </p>
          <button
            onClick={() => { setSent(false); setForm({ feedback_type: "General Feedback", subject: "", message: "" }); }}
            style={{
              background: "linear-gradient(135deg, #2ec4b6, #1a9e92)",
              color: "#0a0f0f", border: "none", borderRadius: "10px",
              padding: "12px 28px", fontSize: "14px", fontWeight: "700", cursor: "pointer",
            }}
          >
            Send Another
          </button>
        </div>
      ) : (
        <div style={card}>
          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <label style={{ fontSize: "13px", fontWeight: "500", color: theme.textSecondary }}>Feedback Type</label>
              <select name="feedback_type" value={form.feedback_type} onChange={handleChange} style={input}>
                {FEEDBACK_TYPES.map((t) => (
                  <option key={t} value={t}>{t}</option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <label style={{ fontSize: "13px", fontWeight: "500", color: theme.textSecondary }}>Subject</label>
              <input
                name="subject" type="text" value={form.subject}
                onChange={handleChange} placeholder="Brief summary of your feedback"
                required style={input}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <label style={{ fontSize: "13px", fontWeight: "500", color: theme.textSecondary }}>Message</label>
              <textarea
                name="message" value={form.message} onChange={handleChange}
                placeholder="Tell us more..." required rows={6}
                style={{ ...input, resize: "vertical", lineHeight: "1.6" }}
              />
            </div>
            <button type="submit" disabled={loading} style={{
              background: "linear-gradient(135deg, #2ec4b6, #1a9e92)",
              color: "#0a0f0f", border: "none", borderRadius: "10px",
              padding: "14px 32px", fontSize: "15px", fontWeight: "700",
              alignSelf: "flex-start", cursor: "pointer",
            }}>
              {loading ? "Sending..." : "Send Feedback"}
            </button>
          </form>
        </div>
      )}

      <div style={{
        background: theme.cardBg, border: `1px solid ${theme.cardBorder}`,
        borderRadius: "14px", padding: "20px 24px", maxWidth: "600px",
        boxShadow: theme.cardShadow,
      }}>
        <p style={{ fontSize: "14px", color: theme.textSecondary }}>
          You can also reach us directly at{" "}
          <a href="mailto:martsenseinfo@gmail.com" style={{ color: "#2ec4b6", textDecoration: "none", fontWeight: "600" }}>
            martsenseinfo@gmail.com
          </a>
        </p>
      </div>
    </Layout>
  );
}